import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import Hub from 'base/hub'
import Event from 'base/event'
import Modal from 'base/react/components/modal'
import CloseIcon from 'base/components/layout/close_icon'
import Login from 'desktop/containers/auth/login'
import { post } from 'base/lib/network'
import apiUrl from 'base/api_url'
import { receiveInitialSession } from 'base/actions/synchronous'

class NewUserModal extends Component {
  static propTypes = {
    siteLocation: PropTypes.string,
    onSignInSuccess: PropTypes.func,
    onRequestClose: PropTypes.func.isRequired,
    hasRepeatUserCookie: PropTypes.bool,
    skipEmailEntry: PropTypes.bool,
    isSigningIn: PropTypes.bool,
    email: PropTypes.string,
    allowLocalhostDevLogin: PropTypes.bool,
  }

  static defaultProps = {
    email: null,
  }

  state = {
    devLoginError: '',
    devLoginLoading: false,
  }

  componentDidMount() {
    Hub.pub(Event.Login.MODAL_VIEW, { site_location: this.props.siteLocation })
  }

  handleRequestClose = () => {
    Hub.pub(Event.Login.MODAL_CLOSED, {
      site_location: this.props.siteLocation,
    })
    this.props.onRequestClose()
  }

  handleSignInSuccess = () => {
    if (this.props.onSignInSuccess) {
      this.props.onSignInSuccess()
    }

    this.props.onRequestClose()
  }

  handleDevLoginSubmit = async e => {
    e.preventDefault()
    const form = e.target
    const email = form.email.value?.trim()
    const password = form.password.value
    if (!email || !password) return
    this.setState({ devLoginError: '', devLoginLoading: true })
    const payload = {
      session: { email, password },
      nextUrl: '/admin',
    }
    this.props
      .devLogin(payload)
      .then(({ session }) => {
        this.props.dispatch(receiveInitialSession(session))
        this.props.onSignInSuccess?.()
        window.location.href = '/admin'
      })
      .catch(() => {
        this.setState({
          devLoginError: 'Invalid email or password.',
          devLoginLoading: false,
        })
      })
  }

  render() {
    const title = (
      <div className="new-user-modal__heading">
        <span className="new-user-modal__title">
          Sign in with your Everlane Google account to access admin
        </span>
      </div>
    )

    const closeIcon = (
      <CloseIcon
        handleClose={this.handleRequestClose}
        className={classNames(
          'new-user-modal__close-button',
          'new-user-modal__close-button--white',
        )}
      />
    )

    return (
      <Modal
        onRequestClose={this.handleRequestClose}
        closeIcon={closeIcon}
        width={800}
        minHeight={0}
        containerClass="new-user-modal-modal-v2"
      >
        <div className={classNames('new-user-modal-content', 'new-user-modal-v2')}>
          <div className="new-user-modal__form">
            <div className="new-user-modal__form-block">
              {title}
              {this.props.allowLocalhostDevLogin && (
                <form onSubmit={this.handleDevLoginSubmit} className="new-user-modal__dev-login">
                  <p className="new-user-modal__dev-login-label">
                    Development: sign in with email &amp; password
                  </p>
                  {this.state.devLoginError && (
                    <p className="new-user-modal__dev-login-error">{this.state.devLoginError}</p>
                  )}
                  <div className="new-user-modal__dev-login-fields">
                    <input
                      type="email"
                      name="email"
                      placeholder="you@everlane.com"
                      autoComplete="email"
                      required
                      disabled={this.state.devLoginLoading}
                      className="new-user-modal__dev-login-input"
                    />
                    <input
                      type="password"
                      name="password"
                      placeholder="Password"
                      autoComplete="current-password"
                      required
                      disabled={this.state.devLoginLoading}
                      className="new-user-modal__dev-login-input"
                    />
                    <button
                      type="submit"
                      disabled={this.state.devLoginLoading}
                      className="new-user-modal__dev-login-submit"
                    >
                      {this.state.devLoginLoading ? 'Signing in…' : 'Sign in'}
                    </button>
                  </div>
                </form>
              )}
              <Login
                email={this.props.email}
                isSigningIn={this.props.isSigningIn}
                onSignInSuccess={this.handleSignInSuccess}
                siteLocation={this.props.siteLocation}
                hasRepeatUserCookie={this.props.hasRepeatUserCookie}
                showExistingUserLink={false}
                isNewUser={false}
                skipEmailEntry={this.props.skipEmailEntry}
                emailOptin={false}
                signInOnly
                googleOnly
              />
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    devLogin: payload => post(apiUrl('login'), payload),
    dispatch,
  }
}

export default connect(null, mapDispatchToProps)(NewUserModal)
